import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterComponent } from '../../molecules/filter/filter.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { News } from '../../../shared/interfaces/news.interface';
import BadgeType from '../../../shared/enums/badge-type.enums';
import ViewportType from '../../../shared/enums/viewport-type.enums';
import { DropdownType } from '../../../shared/enums/dropdown-type.enums';
import { CapitalizePipe } from '../../capitalize.pipe';

@Component({
  selector: 'hdi-filter-bar',
  standalone: true,
  imports: [CommonModule, FilterComponent, DropdownComponent, CapitalizePipe],
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class FilterBarComponent implements OnInit, OnChanges {
  @Input() viewport: ViewportType = ViewportType.desktop;
  @Input() news: News[] = [];
  @Input() caasFilters?: { filter: string; categories: string[] }[];
  @Output() filteredNews = new EventEmitter<News[]>();
  public filters: string[] = [];
  public selectedFilter: string = 'Alle';
  public selectedFilterCaas?: { filter: string; categories: string[] };

  BadgeType = BadgeType;
  DropdownType = DropdownType;

  ngOnInit(): void {
    if (!this.caasFilters) {
      this.filters = this.getCategoriesNews();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasFilters']) {
      const categories = this.getCategoriesNews();
      this.caasFilters = this.caasFilters?.filter((filter) =>
        filter.categories.some((category) => categories.includes(category))
      );
    }
  }

  get filtersMobile(): string[] {
    if (!this.caasFilters) {
      return ['Alle', ...this.filters];
    } else {
      return ['Alle', ...this.caasFilters.map((filter) => filter.filter)];
    }
  }

  getCategoriesNews(): string[] {
    return this.news
      .flatMap((news) =>
        news.badges.filter((badge) => badge.type === BadgeType.DEFAULT)
      )
      .map((badge) => badge.label)
      .filter(
        (label, index, self) => index === self.findIndex((l) => l === label)
      );
  }

  handleClick(label: string) {
    this.selectedFilter = label;
    if (!this.caasFilters) {
      this.filteredNews.emit(this.filterNews());
    } else {
      this.selectedFilterCaas = this.caasFilters?.find(
        (filter) => filter.filter === label
      );
      this.filteredNews.emit(this.filterNewsCaas());
    }
  }

  filterNews() {
    if (this.selectedFilter === 'Alle') {
      return this.news;
    } else {
      return this.news.filter((news) =>
        news.badges.some((badge) => badge.label === this.selectedFilter)
      );
    }
  }

  filterNewsCaas() {
    if (this.selectedFilter === 'Alle') {
      return this.news;
    } else {
      return this.news.filter((news) =>
        news.badges.some((badge) =>
          this.selectedFilterCaas?.categories.includes(badge.label)
        )
      );
    }
  }
}
